import React, { useState } from 'react'
import { DropdownPill, DropdownPillSyncProps } from 'components/common/dropdown_pill/DropdownPill'
import { ProCheckbox } from 'components/ProCheckbox'

enum ReviewRating {
  Star5 = '5',
  Star4 = '4',
  Star3 = '3',
  Star2 = '2',
  Star1 = '1'
}

export type RatingSelections = ReviewRating[]

interface RatingFilterBaseProps {
  onChange: (selections: RatingSelections) => void
}

type RatingFilterProps = RatingFilterBaseProps & Partial<DropdownPillSyncProps>

export const AllReviewRatingSelectors = Object.values(ReviewRating)

const sortReviewSelections = (ratings: RatingSelections): RatingSelections => ratings.sort(
  (a, b) => (AllReviewRatingSelectors.indexOf(a) - AllReviewRatingSelectors.indexOf(b))
)

export const RatingFilter: React.FC<RatingFilterProps> = (props) => {
  const { onChange } = props
  const [isAllSelected, setIsAllSelected] = useState<boolean>(true)
  const [selections, setSelections] = useState<RatingSelections>(AllReviewRatingSelectors)

  const syncProps: DropdownPillSyncProps = {
    id: props.id ?? 'none',
    isExpanded: props.isExpanded ?? false,
    onClick: props.onClick ?? (() => { console.error('Dropdown onClick handler not set') })
  }

  const handleChange = (selections: RatingSelections): void => {
    const sortedSelections = sortReviewSelections(selections)
    setSelections(sortedSelections)
    onChange(sortedSelections)
  }

  const toggleAllChecked = (): void => {
    const wasAllSelected = isAllSelected
    const updatedSelection = wasAllSelected ? [] : AllReviewRatingSelectors
    setIsAllSelected(!wasAllSelected)
    handleChange(updatedSelection)
  }

  const updateSelection = (selectedItem: ReviewRating) => () => {
    setIsAllSelected(false)
    const updatedSelections = selections.includes(selectedItem)
      // remove item from array
      ? selections.filter(i => i !== selectedItem)
      // add item to array
      : [selectedItem, ...selections]
    handleChange(updatedSelections)
  }

  const rating5 = ReviewRating.Star5
  const rating4 = ReviewRating.Star4
  const rating3 = ReviewRating.Star3
  const rating2 = ReviewRating.Star2
  const rating1 = ReviewRating.Star1

  const ratingsFilterLabel = (): string => {
    if (isAllSelected || selections.length === 0) { return 'Rating' }
    if (selections.length === AllReviewRatingSelectors.length) { return 'All Ratings' }
    if (selections.length === 1) {
      if (selections[0] === ReviewRating.Star1) {
        return '1 Star'
      } else {
        return `${selections[0]} Stars`
      }
    }
    const [lastValue, ...rest] = selections
    const commaSeparated = rest.reverse().join(',')
    return `${commaSeparated} & ${lastValue} Stars`
  }

  return (
    <DropdownPill labelText={ratingsFilterLabel()} canClickOnContent={false} {...syncProps}>
      <div className='review-ratings-filter review-filter'>
        <div className='review-ratings-checklist'>
          <ProCheckbox isChecked={isAllSelected} setIsChecked={toggleAllChecked} name='all'>All Ratings</ProCheckbox>
          <ProCheckbox isChecked={selections.includes(rating5)} setIsChecked={updateSelection(rating5)} name='5star'>5 Stars</ProCheckbox>
          <ProCheckbox isChecked={selections.includes(rating4)} setIsChecked={updateSelection(rating4)} name='4star'>4 Stars</ProCheckbox>
          <ProCheckbox isChecked={selections.includes(rating3)} setIsChecked={updateSelection(rating3)} name='3star'>3 Stars</ProCheckbox>
          <ProCheckbox isChecked={selections.includes(rating2)} setIsChecked={updateSelection(rating2)} name='2star'>2 Stars</ProCheckbox>
          <ProCheckbox isChecked={selections.includes(rating1)} setIsChecked={updateSelection(rating1)} name='1star'>1 Star</ProCheckbox>
        </div>
      </div>
    </DropdownPill>
  )
}
